import React from 'react';
// import ReactDOM from 'react-dom';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import { LicenseInfo } from '@mui/x-license';
import mixpanel from 'mixpanel-browser';

import 'typeface-roboto';
import './index.css';
import { createRoot } from 'react-dom/client';

import { env } from 'config';
import { colors } from 'theme/colors';

import App from './containers/App';
import { initSentry } from './sentry';
import { registerStaleChunkRecovery } from './utils/staleChunk';
import { initLogging, initAxiosInterceptors } from './utils/config';

// Before Sentry, so a reload is under way by the time Sentry's own rejection handler reports it.
registerStaleChunkRecovery();
initSentry();
initLogging();
initAxiosInterceptors();
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);

LicenseInfo.setLicenseKey(env.REACT_APP_MUI_X_LICENSE_KEY as string);

// oxlint-disable-next-line no-console
console.log(
  `%cversion 🚀️︎🌕: ${env.REACT_APP_NAME} ${env.REACT_APP_VERSION}`,
  `color:${colors.primary.main}; font-size: 28px`
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

mixpanel.init(env.REACT_APP_MIXPANEL_TOKEN as string, {
  debug: Boolean(Number(env.REACT_APP_ENABLE_MIXPANEL_LOGGING)),
  track_pageview: false, // manual page view tracking by listening to react-router-dom history
  persistence: 'localStorage',
  // Our projects are EU data residency. Mixpanel stopped forwarding US-ingested
  // events to EU servers, so the default US host would silently drop our data.
  api_host: 'https://api-eu.mixpanel.com',
});

mixpanel.register({ platform: 'web' });
